function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 7h17V4.5h-17V7zM2 4.5c0-.4.15-.75.45-1.05.3-.3.65-.45 1.05-.45h17c.4 0 .75.15 1.05.45.3.3.45.65.45 1.05v5.975H3.5V17.5h5.825V19H3.5c-.4 0-.75-.15-1.05-.45-.3-.3-.45-.65-.45-1.05v-13zM14.95 21l-4.25-4.25 1.075-1.075 3.175 3.175 6-6 1.05 1.1L14.95 21zM3.5 4.5v13-3.95 3.25V4.5z",
  fill: "currentColor"
});
var SvgPaymentMethod = function SvgPaymentMethod(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
};
export default SvgPaymentMethod;